import { render, staticRenderFns } from "./ZMenu.vue?vue&type=template&id=dbe248b4&scoped=true&"
import script from "./ZMenu.vue?vue&type=script&lang=js&"
export * from "./ZMenu.vue?vue&type=script&lang=js&"
import style0 from "./ZMenu.vue?vue&type=style&index=0&id=dbe248b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe248b4",
  null
  
)

export default component.exports